import type { Category } from './types';

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '足球',
    slug: 'football',
    icon: 'ri-football-line',
    description: '全球足球赛事资讯，五大联赛、欧冠、世界杯等顶级赛事全覆盖',
    articleCount: 128,
  },
  {
    id: 'cat-2',
    name: '篮球',
    slug: 'basketball',
    icon: 'ri-basketball-line',
    description: 'NBA、CBA、欧洲篮球联赛等全球顶级篮球赛事最新动态',
    articleCount: 96,
  },
  {
    id: 'cat-3',
    name: '网球',
    slug: 'tennis',
    icon: 'ri-base-station-line',
    description: '四大满贯、ATP、WTA巡回赛实时战报与深度分析',
    articleCount: 64,
  },
  {
    id: 'cat-4',
    name: '电竞',
    slug: 'esports',
    icon: 'ri-gamepad-line',
    description: '英雄联盟、DOTA2、CS2等顶级电竞赛事全程追踪',
    articleCount: 112,
  },
  {
    id: 'cat-5',
    name: '赛车',
    slug: 'racing',
    icon: 'ri-steering-2-line',
    description: 'F1、MotoGP、WRC等世界顶级赛车运动全面报道',
    articleCount: 42,
  },
  {
    id: 'cat-6',
    name: '搏击',
    slug: 'combat',
    icon: 'ri-boxing-line',
    description: 'UFC、拳击、综合格斗等搏击赛事权威资讯',
    articleCount: 38,
  },
  {
    id: 'cat-7',
    name: '高尔夫',
    slug: 'golf',
    icon: 'ri-golf-ball-line',
    description: 'PGA巡回赛、大师赛等全球高尔夫盛事专业解读',
    articleCount: 28,
  },
  {
    id: 'cat-8',
    name: '综合',
    slug: 'general',
    icon: 'ri-medal-line',
    description: '奥运会、亚运会、田径、游泳等综合性体育赛事',
    articleCount: 56,
  },
];